module.exports = __webpack_public_path__ + "img/package.52cf4686.svg";